/**
 * Fold a color name for MATCHING across catalogs and stored selections.
 *
 * Folds case, whitespace runs, the padding around a slash (the slash itself
 * is kept -- "Charcoal/ Black" is a different color from "Charcoal"), and a
 * single trailing SanMar `*` version marker: the SAME variance the backend's
 * catalog validator folds. Without the fold a stored `"Coyote Brown "` or
 * `"Neon Blue*"` would not match its own catalog row.
 *
 * Used by ColorsPanel (stranded-color ghosts) and SupplierSkuPanel (which
 * selected colors survive a confirmed SKU swap).
 *
 * @param {string} name
 * @returns {string} the folded key, or '' for a missing/non-string name.
 */
export function normalizeColorNameForMatch (name) {
  if (typeof name !== 'string' || !name) return ''
  let out = name.replace(/\s+$/, '')
  if (out.endsWith('*')) out = out.slice(0, -1)
  return out
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s*\/\s*/g, '/')
    .toLowerCase()
}
